import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateManyAuthorizedSignersMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  prefix: Types.Scalars['String'];
  amount: Types.Scalars['Int'];
}>;


export type CreateManyAuthorizedSignersMutation = { __typename?: 'Mutation', createManyAuthorizedSigners: number };


export const CreateManyAuthorizedSignersDocument = gql`
    mutation CreateManyAuthorizedSigners($event_account_id: ID!, $prefix: String!, $amount: Int!) {
  createManyAuthorizedSigners(
    event_account_id: $event_account_id
    prefix: $prefix
    amount: $amount
  )
}
    `;
export type CreateManyAuthorizedSignersMutationFn = Apollo.MutationFunction<CreateManyAuthorizedSignersMutation, CreateManyAuthorizedSignersMutationVariables>;

/**
 * __useCreateManyAuthorizedSignersMutation__
 *
 * To run a mutation, you first call `useCreateManyAuthorizedSignersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyAuthorizedSignersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyAuthorizedSignersMutation, { data, loading, error }] = useCreateManyAuthorizedSignersMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      prefix: // value for 'prefix'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateManyAuthorizedSignersMutation(baseOptions?: Apollo.MutationHookOptions<CreateManyAuthorizedSignersMutation, CreateManyAuthorizedSignersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManyAuthorizedSignersMutation, CreateManyAuthorizedSignersMutationVariables>(CreateManyAuthorizedSignersDocument, options);
      }
export type CreateManyAuthorizedSignersMutationHookResult = ReturnType<typeof useCreateManyAuthorizedSignersMutation>;
export type CreateManyAuthorizedSignersMutationResult = Apollo.MutationResult<CreateManyAuthorizedSignersMutation>;
export type CreateManyAuthorizedSignersMutationOptions = Apollo.BaseMutationOptions<CreateManyAuthorizedSignersMutation, CreateManyAuthorizedSignersMutationVariables>;